import { createContext, useContext } from "react";
export var anchorContextDefaultValue = {};
/**
 * Carries the HTML anchor configured on a WordPress block down to the element
 * that should receive the `id`. A context is used instead of a wrapper element
 * because providers render no DOM node, which keeps the `section + section`
 * adjacent sibling selectors used for padding collapsing intact.
 */ export var AnchorContext = /*#__PURE__*/ createContext(anchorContextDefaultValue);
/**
 * Returns the anchor for the current block, if any. The anchor is meant to be
 * applied only once, so consumers should render `AnchorContext.Provider` with
 * `anchorContextDefaultValue` around their children to prevent nested elements
 * from claiming the same id.
 */ export function useAnchor() {
    return useContext(AnchorContext).anchor || undefined;
}

//# sourceMappingURL=AnchorContext.js.map